export default __webpack_public_path__ + "static/media/sounds/maze_model_option_bus_alyx.mp3";